import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { usePmsTheme } from "../../../Components/PmsThemeContext";
import "../stockOperationsUi";
import "../../PurchasingUi.css";

const focusSelector = 'button:not(:disabled), [href], input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]';

/** Portal keeps stock forms outside workspace scroll/zoom. Backdrop clicks never discard work. */
export default function StockOperationsDialog({ title, onClose, dismissible = true, busy = false, className = "so-modal--wide", children }) {
  const { themeId } = usePmsTheme();
  const cardRef = useRef(null);
  const closeRef = useRef({ onClose, dismissible, busy });
  closeRef.current = { onClose, dismissible, busy };
  useEffect(() => {
    const previousFocus = document.activeElement;
    const card = cardRef.current;
    const isTopmost = () => !document.querySelector(".pu-document-confirm") && [...document.querySelectorAll("[data-stock-dialog]")].at(-1) === card;
    const focusable = () => [...card.querySelectorAll(focusSelector)].filter((element) => element.getAttribute("aria-hidden") !== "true");
    card.focus();
    const onKey = (event) => {
      if (!isTopmost()) return;
      if (event.key === "Escape" && closeRef.current.dismissible && !closeRef.current.busy) {
        event.preventDefault(); event.stopPropagation(); closeRef.current.onClose?.();
      }
      if (event.key !== "Tab") return;
      const elements = focusable();
      const first = elements[0] || card;
      const last = elements[elements.length - 1] || card;
      if (!card.contains(document.activeElement) || document.activeElement === card) {
        event.preventDefault(); (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    };
    const keepFocus = (event) => { if (isTopmost() && !card.contains(event.target)) card.focus(); };
    document.addEventListener("keydown", onKey);
    document.addEventListener("focusin", keepFocus);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("focusin", keepFocus);
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, []);
  return createPortal(
    <div className="pilcore-purchasing-overlay stock-operations-overlay so-modalOverlay" data-theme={themeId}>
      <section ref={cardRef} className={`so-modal ${className}`} role="dialog" aria-modal="true" aria-label={title} aria-busy={busy} tabIndex={-1} data-stock-dialog>
        {children}
      </section>
    </div>, document.body
  );
}
